export const META_BACK = "META_BACK";
export const META_BACK_ROUTE = "META_BACK_ROUTE";
export const META_MOBILE_NAVIGATION_TABS = "META_MOBILE_NAVIGATION_TABS";
export const META_DASHBOARD_TABS = "META_DASHBOARD_TABS";
export const META_DASHBOARD_SIDEMENU = "META_DASHBOARD_SIDEMENU";
export const META_DASHBOARD_DETAIL_OPENED = "META_DASHBOARD_DETAIL_OPENED";
export const META_PROGRESS = "META_PROGRESS";
export const META_STEPS = "META_STEPS";
export const META_STEPS_DEFINITIONS = "META_STEPS_DEFINITIONS";
export const META_IS_BOOKING_EXPRESS = "META_IS_BOOKING_EXPRESS";

export const ROUTE_DASHBOARD = "dashboard";
export const ROUTE_USER_MENU = "user-menu";
export const ROUTE_PAYMENT = "payment";
export const ROUTE_ACCOUNT = "account";
export const ROUTE_CREATION = "creation";
export const ROUTE_MULTI_ACCOUNT = "multi-account";

export const ETAB_ROUTES = {
  loading: { path: "", name: "loading" }, // app first page
  candidateReference: { path: "candidate-reference", name: "candidate-reference" },
  auth: {
    root: { path: "auth", name: "auth" },
    landing: { path: "landing", name: "auth-landing" },
    login: { path: "login", name: "auth-login" },
    signup: { path: "signup", name: "auth-signup" },
    wrongApp: { path: "wrong-app", name: "auth-wrong-app" },
  },
  account: {
    root: { path: "account", name: ROUTE_ACCOUNT },
    cgu: { path: "cgu", name: "account-cgu" },
    confidentiality: { path: "confidentiality", name: "account-confidentiality" },
    onboarding: { path: "onboarding", name: "account-onboarding" },
    profile: {
      root: { path: "profile", name: "account-profile" },
      info: { path: "info", name: "account-profile-info" },
      cropper: { path: "cropper", name: "account-profile-cropper" },
    },
    accountInformations: { path: "account-informations", name: "account-informations" },
    documents: {
      root: { path: "mes-documents", name: "documents" },
      slug: { path: ":documentSlug", name: "documents-slug" },
    },
    adminFolder: { path: "admin-folder", name: "admin-folder" },
    adminFolderStatus: { path: "admin-folder-status", name: "admin-folder-status" },
    paymentMeans: { path: "payment-means", name: "payment-means" },
    multiAccount: { path: "multi-account", name: "multi-account" },
    developer: { path: "developer", name: "developer-tools" },
  },
  subscription: {
    menu: { path: "subscription-menu", name: "subscription-menu" },
    demand: { path: "subscription-demand/:demandId?", name: "subscription-demand" },
  },
  upfront: { path: "upfront/:demandId?", name: "upfront" },
  creationSuccess: { path: "success", name: "creation-success" },
  creation: {
    root: { path: "creation", name: ROUTE_CREATION },
    home: { path: "home", name: "creation-home" },
    error: { path: "error", name: "creation-error" },
    funnel: {
      root: { path: "", name: "creation-funnel" },
      step: {
        root: { path: "", name: "creation-step" },
        slug: { path: ":templateId/:stepSlug", name: "creation-step-slug" },
      },
    },
  },
  dashboard: {
    root: { path: "dashboard", name: ROUTE_DASHBOARD },
    tabs: {
      root: { path: "", name: "dashboard-tabs" }, // path: "" in order to keep the dashboard tab activated
      upcoming: { path: "upcoming", name: "dashboard-tabs-upcoming" },
      inProgress: { path: "in-progress", name: "dashboard-tabs-in-progress" },
    },
    planning: {
      root: { path: "planning", name: "planning" },
      mission: { path: "mission/:missionId/extra/:extraId", name: "planning-mission" },
    },
    recruitment: {
      root: { path: "recruitment", name: "recruitment" },
      temporary: {
        root: { path: "temporary/:demandType/:demandId/:demandTemporaryId", name: "recruitment-temporary" },
        detail: {
          root: { path: "detail", name: "recruitment-temporary-detail" },
          applied: { path: "applied", name: "recruitment-temporary-applied" },
          selected: { path: "selected", name: "recruitment-temporary-selected" },
        },
        activation: {
          root: { path: "activation", name: "recruitment-temporary-activation" },
          success: { path: "success", name: "recruitment-temporary-activation-success" },
        },
        candidate: {
          root: { path: "candidate/:candidateId", name: "recruitment-temporary-candidate" },
          mission: { path: "mission", name: "recruitment-temporary-candidate-mission" },
          profile: { path: "profile", name: "recruitment-temporary-candidate-profile" },
        },
      },
      permanent: {
        root: { path: "permanent/:demandType/:demandId", name: "recruitment-permanent" },
        activation: {
          root: { path: "activation", name: "recruitment-permanent-activation" },
          payment: { path: "payment", name: "recruitment-permanent-activation-permanent" },
          success: { path: "success", name: "recruitment-permanent-activation-success" },
        },
        detail: {
          root: { path: "detail", name: "recruitment-permanent-detail" },
          applied: { path: "applied", name: "recruitment-permanent-applied" },
          contacted: { path: "contacted", name: "recruitment-permanent-contacted" },
          ignored: { path: "ignored", name: "recruitment-permanent-ignored" },
          locked: { path: "locked", name: "recruitment-permanent-locked" },
        },
        feedback: {
          root: { path: "feedback", name: "recruitment-permanent-feedback" },
          recruited: { path: "recruited", name: "recruitment-permanent-recruited" },
          notRecruited: { path: "not-recruited", name: "recruitment-permanent-not-recruited" },
        },
        candidate: {
          root: { path: "candidate/:candidateId?", name: "recruitment-permanent-candidate" },
          profile: { path: "profile", name: "recruitment-permanent-candidate-profile" },
        },
      },
    },
  },
  userMenu: {
    root: { path: "user-menu", name: ROUTE_USER_MENU },
    main: { path: "main", name: "user-menu-main" },
    more: { path: "more", name: "user-menu-more" },
  },
  payment: {
    root: { path: "payment", name: ROUTE_PAYMENT },
    means: { path: "means", name: "payment-means" },
    cards: { path: "cards", name: "payment-cards" },
    iban: { path: "iban", name: "iban" },
    addCard: { path: "add-card", name: "payment-add-card" },
    addAndPay: { path: "add-and-pay", name: "payment-add-and-pay" },
  },
  signup: {
    root: { path: "signup", name: "signup" },
    steps: {
      root: { path: "steps", name: "signup-steps" },
      success: { path: "success", name: "signup-success" },
      main: { path: "main", name: "signup-steps-main" },
      info: {
        root: { path: "info", name: "signup-steps-info" },
        full: { path: "full", name: "signup-steps-info-full" },
        alt: { path: "alt", name: "signup-steps-info-alt" },
      },
    },
  },
  smartRedirect: { path: "smart-redirect", name: "smart-redirect" },
  startup: { path: "startup", name: "startup" },
  survey: { path: "survey", name: "survey" },
  update: { path: "update", name: "force-update-required" },
};
